import * as helpers from "../helpers";

const validate = (form) => {
  let isValid = true;
  let firstWrongField = null;

  helpers.resetErrors(form);

  const dataType = form.querySelector('button[data-type].active');
  if (dataType) {
    const type = dataType.getAttribute('data-type');
    const fields = form.querySelectorAll(`#${type} input`);

    if (fields.length > 0) {
      fields.forEach(field => {
        if (field.name == 'customer_first_name') {
          if (/^(?![a-zęóąśłżźćń]+$)/i.test(field.value)) {
            helpers.error('Błędne imie', field.name);
            isValid = false;
            if (!firstWrongField) firstWrongField = field;
          }
        } else if (field.name == 'customer_last_name') {
          if (/^(?![a-zęóąśłżźćń]+(-[a-zęóąśłżźćń]+)?$)/i.test(field.value)) {
            helpers.error('Błędne nazwisko', field.name);
            isValid = false;
            if (!firstWrongField) firstWrongField = field;
          }
        } else if (field.name == 'company_name') {
          if (/^(?![a-zęóąśłżźćń0-9\-\.\,\s]+$)/i.test(field.value)) {
            helpers.error('Błędna nazwa firmy', field.name);
            isValid = false;
            if (!firstWrongField) firstWrongField = field;
          }
        }
      });
    }
  }

  const email = form.querySelector('[name="customer_email"]');
  if (/^(?!\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$)/.test(email.value)) {
    helpers.error('Błędny adres e-mail', email.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = email;
  }

  const country = form.querySelector('[name="tax_country"]');
  if (/^(?![a-zęóąśłżźćń0-9\-]+$)/i.test(country.value)) {
    helpers.error('Błędna nazwa kraju', country.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = country;
  }

  const street = form.querySelector('[name="street"]');
  if (/^(?![a-zęóąśłżźćń0-9\-\.\,\s]+$)/i.test(street.value)) {
    helpers.error('Błędna nazwa ulicy', street.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = street;
  }

  const streetHouseNo = form.querySelector('[name="street_house_no"]');
  if (/^(?![\d]+([\s][a-z{,1}]||[a-z{,1}])$)/.test(streetHouseNo.value)) {
    helpers.error('Błędny numer', streetHouseNo.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = streetHouseNo;
  }

  const streetStaicaseNo = form.querySelector('[name="street_staircase_no"]');
  if (streetStaicaseNo.value != '' && /^(?![\d]+([\s][a-z{,1}]||[a-z{,1}])$)/.test(streetStaicaseNo.value)) {
    helpers.error('Błędny numer', streetStaicaseNo.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = streetStaicaseNo;
  }

  const city = form.querySelector('[name="city"]');
  if (/^(?![a-zęóąśłżźćń\-\.\,\s\d]+$)/i.test(city.value)) {
    helpers.error('Błędna nazwa', city.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = city;
  }

  const postalCode = form.querySelector('[name="postal_code"]');
  if (/^(?![\d\-]+$)/i.test(postalCode.value)) {
    helpers.error('Błędny kod', postalCode.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = postalCode;
  }

  const documentType = form.querySelector('[name="document_type"]');
  if (documentType.value === '') {
    helpers.error('Błędny typ', documentType.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = documentType;
  }

  const periodYear = form.querySelector('[name="period_year"]');
  if (periodYear.value === '') {
    helpers.error('Błędny rok', periodYear.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = periodYear;
  }

  const periodType = form.querySelector('[name="period_type"]');
  if (periodType.value === '') {
    helpers.error('Błędny okres', periodType.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = periodType;
  }

  const periodNo = form.querySelector('[name="period_no"]');
  if (periodNo.value != '' && /^(?![\d]+$)/i.test(periodNo.value)) {
    helpers.error('Błędny okres', periodNo.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = periodNo;
  }

  const taxAmount = form.querySelector('[name="tax_amount"]');
  if (/^(?![\d\,\.]+$)/.test(taxAmount.value)) {
    helpers.error('Błędna kwota', taxAmount.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = taxAmount;
  }
  if ( /^[\d\,\.]+$/.test(taxAmount.value) && (parseFloat(taxAmount.value.replace(',','.')) > parseFloat('4300.00')) ) {
    helpers.error('Kwota maksymalna to 4300 zł', taxAmount.name);
    isValid = false;
    if (!firstWrongField) firstWrongField = taxAmount;
  }

  if (!isValid && firstWrongField) firstWrongField.scrollIntoView({behavior: "smooth", block: "center"});

  // ---- Start test ----
  // const test = form.querySelectorAll('[name]');
  // test.forEach(item => {
  //   console.log(item.name, item.value);
  // })
  // console.log("Is form valid: ", isValid);
  // return false;
  // ---- End test ----

  return isValid;
};

export default validate;